import { useDocumentTitle } from "usehooks-ts";
import { DataTableContextProvider } from "../DataTable/DataTableContext";
import { EmptyCell } from "../DataTable/EmptyCell";
import { DataTable } from "../DataTable/DataTable";

const LtiErrors = () => {
  useDocumentTitle("LTI Logs");

  return (
    <div>
      <DataTableContextProvider
        source={`/manager_new/integrations/errored-logs`}
        queryKey="lti-errors"
        defaults={{ sortBy: [{ id: "createdAt", desc: true }], pageSize: 50 }}
        sortable={["createdAt"]}
        fetchOnLoad
        filterable={["errorCode", "email", "consumerKey"]}
        columnOverrides={{
          custom_section_names: ({ value }) =>
            !value ? (
              <EmptyCell />
            ) : typeof value === "string" ? (
              <pre>{JSON.stringify(JSON.parse(value), null, 2)}</pre>
            ) : (
              <pre>{String(value)}</pre>
            ),
        }}
      >
        <DataTable />
      </DataTableContextProvider>
    </div>
  );
};

export default LtiErrors;
